import React, { useState } from "react";
import "../css/appStyling.css";

import myLogo from '../Assets/gr-logo-640px-webp.webp';
import { Link } from "react-router-dom";
 
// One way to use images is to keep them in public folder and write in this way
// const mylogo = process.env.PUBLIC_URL + "Assets/";

export default function Navbar() {

// const [defaultTheme, setTheme]  = useState({backgroundColor: "#00008b"});

//  const handleCheckBox = (event) => {

//     // console.log(event.target.checked);
// if (event.target.checked) {
//   setTheme({
//     backgroundColor: "#121212",
    
//   })
// } else  {
//   setTheme({
//     backgroundColor: "background: hsl(265 100% 10% / 1) !important;"
//   }) 
// } 

//   }
  return (
    <nav className="w-100">
      <div className="myLogo">
        <Link to="/">
          <img src={myLogo}  alt="gr-logo" />
        </Link>
      </div>

      <ul className="navbar-items">
        <li className="nav-item">
          <Link to="/about">About</Link>
        </li>
        <li className="nav-item">
          <Link to="/projects">Projects</Link>
        </li>
        <li className="nav-item">
          <Link to="/uses-by-grohit">Uses</Link>
        </li>
        <li className="nav-item">
          <Link to="/contact">Contact</Link>
        </li>

        
    {/* <li className="nav-item pageMode">
      <label htmlFor="pageMode">Theme:</label> 
    <input type="checkbox" name="pageMode" onClick={handleCheckBox} value="Darkmode"/>
    </li> */}

      </ul>

<Link to='/blog' className="button blog">Blog</Link>
    </nav>
  );
}
